import { API_ENDPOINTS } from './Constants';
import { apiFetch } from './apiHelper';

const ReviewService = {
    getReviews: async (bookId) => {
        try {
            const res = await apiFetch(API_ENDPOINTS.BOOK_REVIEWS(bookId));
            if (!res.ok) return [];
            return await res.json();
        } catch {
            return [];
        }
    },

    getSummary: async (bookId) => {
        try {
            const res = await apiFetch(API_ENDPOINTS.BOOK_REVIEWS_SUMMARY(bookId));
            if (!res.ok) return null;
            return await res.json();
        } catch {
            return null;
        }
    },

    addOrUpdate: async (bookId, rating, comment) => {
        const res = await apiFetch(API_ENDPOINTS.BOOK_REVIEWS(bookId), {
            method: 'POST',
            body: JSON.stringify({ rating, comment: comment || null }),
            credentials: 'include',
        });
        if (!res.ok) {
            const text = await res.text().catch(() => '');
            throw new Error(text || 'Greška pri spremanju recenzije');
        }
        return await res.json();
    },

    deleteReview: async (bookId) => {
        const res = await apiFetch(API_ENDPOINTS.BOOK_REVIEWS(bookId), {
            method: 'DELETE',
            credentials: 'include',
        });
        if (!res.ok) throw new Error('Greška pri brisanju recenzije');
    },
};

export default ReviewService;
